import {
  atomsLabelTwObjs,
  catcherMittBackofBeltBackStylePartsTwObjs,
  catcherMittBackofRegularBackStylePartsTwObjs,
  catcherMittBackPartsTwObjs,
  catcherMittCatchFaceTwObjs,
  catchFacePartsTwObjs,
  dispatchTwObjects,
  dispatchEuropeanSteerTw,
  firstMittBackPartsTwObjs,
  firstMittBackPartsNoBeltTwObjs,
  gloveBeltBackPartsTwObjs,
  gloveBeltBackPartsNoBeltTwObjs,
  gloveCrownBackPartsTwObjs,
  gloveFirstBackPartsTwObjs,
  gloveUsBackPartsTwObjs,
  hamidashiAllTwObjs,
  hamidashiTwObjs,
  hamidashiForCatcherTwObjs,
  laceColorTwObjs,
  leatherColorObjsTw,
  listLiningsMaterialTwObjs,
  stitchColorTwObjs,
  tannerTwObjs,
  tannerObjs,
  uBackTwObjs,
  dispatchNorthSteerTw,
  dispatchSteerTw,
  BINDING_COLORS_TW
} from 'src/features/atoms/glove/tw/constants/colors'
import {
  backLaceTwObjs,
  backStyleTwObjs,
  backStyleForCatcherMittTwObjs,
  backStyleForPitcherTwObjs,
  dominantArmTwObjs,
  fingerGuardForFirstMittTwObjs,
  fingerGuardTypeAllTwObjects,
  fingerGuardTypeTwObjs,
  fingerGuardTypeForOutfielderTwObjs,
  loopOfRingFingerTwObjs,
  materialPackTwObjs,
  moldingTwObjs,
  sizeTwObjs,
  printLeatherTypeTwObjs
} from 'src/features/atoms/glove/tw/constants/bases'
import {
  colorTwObjs,
  positionTwObjs,
  shadowEdgeColorTwObjs,
  typeFaceTwAllObjs,
  typeFaceTwObjs
} from 'src/features/atoms/glove/tw/constants/embroidery'
import { initialYouthState } from 'src/features/atoms/glove/japan/slice/youth'
import {
  initialOutfielderStateTw,
  initialPitcherStateTw,
  initialInfielderStateTw,
  initialStateCatcherMittTw,
  initialStateFirstMittTw
} from 'src/features/atoms/glove/tw/slice'

export const leagueTwOptions = [
  { label: '職業棒球', value: 'プロ野球' },
  { label: '甲組成棒', value: '社会人野球' },
  { label: '大學棒球', value: '大学野球' },
  { label: '高中棒球', value: '高校野球' },
  { label: '業餘愛好', value: '草野球' }
]

const positionTwOptions = [
  { label: '投手', value: 'pitcher', attribute: 'pitcher' },
  { label: '捕手', value: 'catcher', attribute: 'catcher' },
  { label: '一壘手', value: 'firstBaseman', attribute: 'first' },
  { label: '二壘手', value: 'secondBaseman', attribute: 'infielder' },
  { label: '三壘手', value: 'thirdBaseman', attribute: 'infielder' },
  { label: '游擊手', value: 'shortStop', attribute: 'infielder' },
  { label: '左外野手', value: 'leftFielder', attribute: 'outfielder' },
  { label: '中外野手', value: 'centerFielder', attribute: 'outfielder' },
  { label: '右外野手', value: 'rightFielder', attribute: 'outfielder' }
]

export default {
  EXPLANATION_OF_PRICES: '所有價格皆含稅。',
  SIMULATABLE_BRANDS: '可模擬的品牌',
  ORDER_SIMULATION: '訂購模擬',
  IF_START_SIMULATION: `※開始模擬時，`,
  IF_START_SIMULATION_2: `視為同意使用條款。`,
  START_BUTTON: '開始模擬',
  CHECK_SIMULATION: '確認模擬',
  TERMS_OF_USE: '使用條款',
  TERMS_OF_USE_ITEM_1: '・本系統旨在為 ATOMS 集團的訂製手套提供模擬功能。',
  TERMS_OF_USE_ITEM_2: '・某些設計和顏色可能與實際產品有所不同。',
  TERMS_OF_USE_ITEM_3: '・高中棒球等各打球層級對使用有所限制，請自行確認。',
  TERMS_OF_USE_ITEM_4: '・對於模擬時發行的手套ID不當使用，本公司不承擔任何責任。',
  TERMS_OF_USE_ITEM_5: '・為保護客戶隱私，我們採用加密等方式努力保護資訊。',
  TERMS_OF_USE_ITEM_6: '・使用本系統須自負責任。對於因使用該系統及與該系統未連結的其他網站獲得的各種資訊而造成的任何損害，本公司不承擔任何責任。',
  TERMS_OF_USE_ITEM_7: '・本公司系統會適時檢討並修訂。',
  TRANSLATE_CAUTION_DESCRIBE: '繼續使用繁體中文系統時，建議關閉Google自動翻譯功能。',
  LEGAL_NOTICE: '法定商業交易法表記',
  FOR_DETAIL: '詳情請見此處↓',
  HOW_TO_OFF_GOOGLE_AUTO_TRANSLATE: '關閉Google Chrome自動翻譯功能的方法',
  DISABLE_MESSAGE_EVER: '不再顯示此訊息。',
  CLOSE: '關閉',
  CHECKOUT: '結帳',
  PRODUCT_PAGE: '產品頁面',
  HARD_GLOVE_MITT: '硬式手套・捕手手套',
  HARD: '硬式',
  SOFT_BALL_GLOVE_MITT: '軟式手套・捕手手套',
  SOFT: '軟式',
  SHOES: '釘鞋',
  BAT: '球棒・打棒',
  GLOVE: '手套',
  MITT: '捕手手套',
  COMMING_SOON: '(準備中)',
  BRAND_SELECTION_PAGE: '品牌選擇頁面',
  POSITION_SELECTION_PAGE: '守備位置',
  SERIES_SELECTION_PAGE: '系列選擇頁面',
  PITCHER: '投手用',
  CATCHER: '捕手用',
  INFIELDER: '內野手用',
  OUTFIELDER: '外野手用',
  FIRST_BASEMAN: '一壘手用',
  JAPAN_SERIES: '日本型號',
  USA_SERIES: '美國型號',
  KOREA_SERIES: '韓國型號',
  PLEASE_SELECT_MODEL: '請選擇基本型號',
  PRODUCT_NUMBER: '型號：',
  START_SIMULATION: '開始模擬',
  US_GLOVE: '美式手套',
  RETAILERS_REQUEST_DESC: '代理商請求系統',
  RETAILERS_LOGIN: '代理商登入',
  RETAIL_LOGIN: '零售商登入',
  US_VERSION: '美版',
  BACK: '返回',
  SELECTED_CATEGORY: '已選擇類別',
  SELECT_CATEGORY_PLEASE: '請選擇類別',
  SIMULATE: '模擬',
  DOMINATE_PRODUCT: '主力產品',
  CATEGORIES: '類別',
  SHOES_CATE: '釘鞋類別',
  SHOES_BRAND: '釘鞋品牌',
  SHOES_SIZE: '釘鞋尺寸',
  MAKER_RECOMMENDATION: '廠商推薦',
  MAKER: '廠商',
  PLEASE_SELECT_POSITION: '請選擇守備位置',
  PITCHED: '投',
  FIRST: '一壘',
  INFIELD: '內野',
  OUTFIELD: '外野',
  YOUTH: '少年用',
  ALL: '全部',
  ALL_PURPOSE: '通用',
  CATCHER_MITT: '捕手手套',
  FIRST_MITT: '一壘手手套',
  FIELDER: '野手',
  USER: '使用者',
  US: '美版',
  MADE_IN: '製造地',
  DETAIL: '詳細',
  PRICE: '價格',
  SIZE: '尺寸',
  SELECT: '選擇',
  DESCRIPTION: '說明',
  RUBBER_COLOR: '橡膠顏色',
  BODY_COLOR: '主體顏色',
  COLOR_CUSTOM: '顏色客製',
  MATERIAL_TYPE: '材質類型',
  SELECT_MATERIAL_PACK: '請選擇材質包',
  SELECTED_MATERIAL_PACK: '已選擇材質包',
  TANNING: '鞣革',
  TANNING_TYPE: '鞣革類型',
  TANNING_COLOR: '鞣革顏色',
  SELECT_TANNING: '請選擇鞣革',
  SELECTED_TANNING: '已選擇鞣革',
  TANNING_EXPLAIN: '鞣革說明',
  LEATHER_COLOR: '皮革顏色',
  LININGS_COLOR: '内裡顏色',
  LININGS_MATERIAL: '内裡材質',
  SELECT_BACK_STYLE: '請選擇背面樣式',
  SELECTED_BACK_STYLE: '已選擇背面樣式',
  BACK_STYLE_EXPLAIN: '背面樣式說明',
  WELTING_COLOR: '夾條顏色',
  WELTING: '夾條',
  LEFT: '左',
  RIGHT: '右',
  CLEAR: '清除',
  INPUT_EMBROIDERY_CONTENT_PLEASE: '請輸入刺繡內容',
  COST: '費用',
  TAX_EXCLUDED_PRICE: '未稅價格',
  TAX_INCLUDED_PRICE: '含稅價格',
  ORDER: '訂購',
  DESCRIPTION_WILL_CHECK_LEAGUE: '※訂購前，我們會確認打球層級等資訊。',
  ORDER_CONFIRM: '訂購確認',
  BACK_TO_SIMULATE: '返回模擬',
  SIMULATION: '模擬',
  GUARANTEE: '保證',
  CAUTION: '注意',
  PLEASE_SELECT_LEAGUE: '※為了您能正確使用，請選擇您所屬的打球層級',
  REQUIRED: '必填',
  NEXT: '下一步',
  U_SHAPE: 'U型',
  T_SHAPE: 'T型',
  GENUINE_LEATHER: '真皮',
  BANK_LACE: '銀行鞋帶',
  JOINT_PARTS_AND_LACE: '接合部位與鞋帶',
  BINDING: '綁定',
  FLAP: '翻蓋',
  EMBROIDERY_TYPES_DATA: typeFaceTwAllObjs,
  EMBROIDERY_POSITION_DATA: positionTwObjs,
  BACK_LACE_DATA: backLaceTwObjs,
  BACK_STYLE_DATA: backStyleTwObjs,
  BACK_STYLE_FOR_CATCHER_MITT_DATA: backStyleForCatcherMittTwObjs,
  BACK_STYLE_FOR_PITCHER_DATA: backStyleForPitcherTwObjs,
  STITCH_COLOR_DATA: stitchColorTwObjs,
  LACE_COLOR_DATA: laceColorTwObjs,
  LEATHER_COLOR_DATA: leatherColorObjsTw,
  LININGS_MATERIAL_DATA: listLiningsMaterialTwObjs,
  MOLDING_DATA: moldingTwObjs,
  SIZE_DATA: sizeTwObjs,
  DOMINANT_ARM_DATA: dominantArmTwObjs,
  LOOP_OF_RING_FINGER_DATA: loopOfRingFingerTwObjs,
  FINGER_GUARD_TYPE_DATA: fingerGuardTypeTwObjs,
  FINGER_GUARD_TYPE_ALL_DATA: fingerGuardTypeAllTwObjects,
  FINGER_GUARD_TYPE_FOR_OUTFIELDER_DATA: fingerGuardTypeForOutfielderTwObjs,
  FINGER_GUARD_FOR_FIRST_MITT_DATA: fingerGuardForFirstMittTwObjs,
  MATERIAL_PACK_DATA: materialPackTwObjs,
  TANNER_DATA: tannerTwObjs,
  TANNER_DATA_OBJECTS: tannerObjs,
  DISPATCH_DATA: dispatchTwObjects,
  DISPATCH_EUROPEAN_STEER_DATA: dispatchEuropeanSteerTw,
  GLOVE_BELT_BACK_PARTS_DATA: gloveBeltBackPartsTwObjs,
  GLOVE_BELT_BACK_PARTS_NO_BELT_DATA: gloveBeltBackPartsNoBeltTwObjs,
  GLOVE_CROWN_BACK_PARTS_DATA: gloveCrownBackPartsTwObjs,
  GLOVE_FIRST_BACK_PARTS_DATA: gloveFirstBackPartsTwObjs,
  GLOVE_US_BACK_PARTS_DATA: gloveUsBackPartsTwObjs,
  CATCHER_MITT_BACK_PARTS_DATA: catcherMittBackPartsTwObjs,
  CATCHER_MITT_CATCH_FACE_DATA: catcherMittCatchFaceTwObjs,
  CATCHER_MITT_BACKOF_BELT_BACK_STYLE_PARTS_DATA: catcherMittBackofBeltBackStylePartsTwObjs,
  CATCHER_MITT_BACKOF_REGULAR_BACK_STYLE_PARTS_DATA: catcherMittBackofRegularBackStylePartsTwObjs,
  FIRST_MITT_BACK_PARTS_DATA: firstMittBackPartsTwObjs,
  FIRST_MITT_BACK_PARTS_NO_BELT_DATA: firstMittBackPartsNoBeltTwObjs,
  CATCH_FACE_PARTS_DATA: catchFacePartsTwObjs,
  U_BACK_DATA: uBackTwObjs,
  HAMIDASHI_DATA: hamidashiTwObjs,
  HAMIDASHI_ALL_DATA: hamidashiAllTwObjs,
  HAMIDASHI_FOR_CATCHER_DATA: hamidashiForCatcherTwObjs,
  ATOMS_LABEL_DATA: atomsLabelTwObjs,
  EMBROIDERY_TYPEFACE_OBJECTS: typeFaceTwObjs,
  EMBROIDERY_COLOR_OBJECTS: colorTwObjs,
  EMBROIDERY_SHADOW_EDGE_COLOR_OBJECTS: shadowEdgeColorTwObjs,
  CAUTION_EMBROIDERY_POSITION: '如要更改刺繡位置，請重設刺繡內容',
  CAUTION_EMBROIDERY_TYPEFACE: '請注意實際字體可能與螢幕顯示有所不同',
  CAUTION_EMBROIDERY_CONTENTS: '請選擇「刺繡位置」。',
  CAUTION_EMBROIDERY_SHADOW_EDGE_COLOR: '請選擇「刺繡顏色」。',
  DESCRIBE_EMBROIDERY_PLUS_BUTTON: '如需2處刺繡位置，請按此「+」顯示刺繡2並輸入。',
  DESCRIBE_EMBROIDERY_MINUS_BUTTON: '如需刪除已輸入刺繡2的1處位置，請按「-」',
  NO_SELECTION: '無選擇',
  SELECT_CARD_WITH_CONFIRM_OPEN_LABEL: '選擇{{summary}}',
  SELECT_CARD_WITH_CONFIRM_DIALOG_TITLE: '選擇{{summary}}',
  SELECT_CARD_WITH_CONFIRM_SELECTED_BADGE: '（選擇中）',
  SELECT_CARD_WITH_CONFIRM_TAX_INCLUDED: '含稅 {{price}}{{unit}}',
  SELECT_CARD_WITH_CONFIRM_AVAILABLE_COLORS_CATCH_FACE: '可選擇的皮革顏色（接球面）',
  SELECT_CARD_WITH_CONFIRM_CANCEL: '取消',
  SELECT_CARD_WITH_CONFIRM_SELECT: '選擇',
  SELECT_CARD_WITH_CONFIRM_SELECT_OPTION: '選擇「{{label}}」',
  SELECT_CARD_WITH_CONFIRM_CAUTION_ONCE_SELECTED: '※一旦選擇後無法變更。',
  INITIAL_STATE_C_MITT: initialStateCatcherMittTw,
  INITIAL_STATE_F_MITT: initialStateFirstMittTw,
  INITIAL_STATE_INFIELDER: initialInfielderStateTw,
  INITIAL_STATE_OUTFIELDER: initialOutfielderStateTw,
  INITIAL_STATE_PITCHER: initialPitcherStateTw,
  INITIAL_STATE_US_GLOVE: initialInfielderStateTw,
  INITIAL_STATE_YOUTH: initialYouthState, // 美版無此項目，暫用日版物件
  TO_OTHER_LANGUAGES_PAGE: '日本語ページへ →',
  SENDING_MAIL: '寄送中...',
  SEND_MAIL_SUCCESS_FULL: '完成！',
  LEAGUE_OPTIONS: leagueTwOptions,
  POSITION_OPTIONS: positionTwOptions,
  BASE_PRICE_GLOVE: 71500,
  BASE_PRICE_MITT: 71500,
  AHN_JAE_SEOK_MODEL: { description: '', size: 0, productNumber: '安宰錫型號' },
  SHIN_JUNG_WOO_MODEL: { description: '', size: 0, productNumber: '申正佑型號' },
  PARK_GE_BUM_MODEL: { description: '', size: 0, productNumber: '朴基範型號' },
  HAFN_DONG_HEE_MODEL: { description: '', size: 0, productNumber: '韓東熙型號' },
  LANGUAGE: '語言',
  WEB2_PARTS_OBJECT: { value: 'web2', label: '球擋2', order: 3 },
  EMBROIDERY_CONTENT_EMOJI_CAUTION: '表情符號・記號僅可刺繡 ⭐︎,🩷',
  // ATOMS模型定義 - 投手用
  AKG_1: { description: '小巧的投手用輕量型號', size: 11.8 },
  AKG_11: { description: '守備時操作靈活的縱型小巧的投手型號。', size: 11.42 },
  AKG_21: { description: 'ATOMS投手用首款縦型・縦縫製手套', size: 11.7 },
  AGL_NE001: { description: '專為投手設計。橫型、接球點較深的型號。', size: 11.81 },
  AGL_NE011: { description: '較小的縱型投手刀模。', size: 11.73 },
  AKG_PRO46: { description: '同AKG-1型，2023年職業選手使用的型號。', size: 11.81 },
  ATR_001: { description: '深型縦型，穩固抓握的投手用。', size: 11.4 },
  US_PITCHER: { description: '縱型深接球點。\n適合喜歡抓握感的投手用。', size: 12.0 },
  // ATOMS模型定義 - 內野手用
  AGL_NE102: { description: '從創立初期的刀模重新設計更適合現代選手。可深可淺使用的型號。', size: 11.14 },
  AGL_NE105: { description: '深接球點，接球安定感佳的全方位型號。適合壘球。', size: 11.42 },
  AGL_NE501: { description: '掌跟較窄，適合喜歡抓握感的選手。', size: 10.94 },
  APL_NE021: { description: '透過整型可調整成深也可以調整成淺的萬用型號。', size: 11.3 },
  APL_NE026: { description: '重視操作性的内野型號。稍小但有深度，適合在虎口接球。', size: 11.14 },
  APL_NE066: { description: '寬入球面，寬接球面，適合接在掌心快速拿球。\n等比例縮小的AKG-6 。', size: 11.42 },
  APL_NE102: { description: '可作為投手跟内野用的型號。', size: 11.14 },
  AKG_JS4_PLUS: { description: '靈活操控，自在應對任何球的型號。', size: 11.29 },
  AKG_JS5: { description: '掌跟較窄，適合喜歡抓握感的選手。', size: 11.14 },
  AKG_16: { description: 'ATOMS最輕量設計、接滾地球最好用的型號。', size: 10.94 },
  AKG_4: { description: '接球面稍寬的型號。', size: 11.02 },
  AKG_5: { description: '可深可淺，最流行的型號。', size: 11.14 },
  AKG_6: { description: '内野唯一採用順蕊。縮小手口寬度的型號。', size: 11.65 },
  APL_UR2: { description: '也可用於橫向的深手套。穩固抓握的二遊間型號。', size: 11.42 },
  APL_UR3: { description: '最淺的手套。比賽用或訓練用都能對應的型號。', size: 10.83 },
  APL_UR4: { description: '球窩不易變深。適合喜歡寬接球面的選手。', size: 11.02 },
  APL_UR5: { description: '游擊手、三壘手用的大小，網周圍不輸強打球的設計。', size: 11.15 },
  APL_UR10: { description: 'U背面採用邊緣付網型號。', size: 11.02 },
  APL_UR026_PLUS: { description: '重視操作性的内野型號。適合接球後快速傳球。', size: 11.14 },
  APL_UR004_PLUS: { description: '採用U形虎口設計、接球面稍寬的型號。', size: 11.02 },
  APL_UR005_PLUS: { description: '安定的抓握感形號，適合游擊或是三壘。', size: 11.14 },
  APL_UR006_PLUS: { description: 'ATR-006的更新型號。職業選手也使用的066等比例加大版。', size: 11.61 },
  APL_UR015_PLUS: { description: '深型穩固包覆型。', size: 11.42 },
  APL_UR066_PLUS: { description: '寬接球面。等比例縮小的AKG-6，提升操作性。', size: 11.42 },
  AGL_105: { description: '接球點深，適合投手跟内野各守備位置。', size: 11.42 },
  AGL_501: { description: '較小的內野手用。手口較小。可對應青少年型。', size: 10.94 },
  AGL_503: { description: '可深廣使用的內野手型號', size: 11.26 },
  AGL_601: { description: '內野手用中較大型的BOX型。', size: 11.65 },
  AGL_603: { description: 'ATOMS較少的橫型內野手型號。較小容易製作口袋，也容易對應逆手型。', size: 11.53 },
  ATR_006: { description: '口袋橫向寬，能碰觸接球或抓握的型。', size: 11.61 },
  US_INFIELDER: { description: '深接球點設計。\n適合喜歡抓握感的選手用。', size: 11.75 },
  // ATOMS模型定義 - 外野手用
  AGL_NE801: { description: '小外野，深接球點的型號。', size: 12.01 },
  AGL_NE008: { description: '大外野，虎口深包覆感佳的型號。', size: 12.99 },
  APL_NE702: { description: '手指細長，深接球點。', size: 12.6 },
  AKG_7: { description: '手指細，虎口較窄減少球在手套内滾動。', size: 12.4 },
  AKG_JS7: { description: '銳利縦型口袋深型號。', size: 12.59 },
  AKG_GT07: { description: '大外野，虎口深包覆感佳的型號', size: 12.99 },
  AKG_17: { description: '口袋深廣，穩固包覆型型號。', size: 12.91 },
  AKG_27: { description: '較小的外野，接球點深。可適用於軟式球。', size: 12.4 },
  ATR_007: { description: '深接球點，安定的接球感。', size: 12.8 },
  AGL_801: { description: '小外野，深接球點的型號', size: 12.01 },
  APL_UR6: { description: '較小但能穩固抓握的型號。', size: 12.4 },
  APL_UR007_PLUS: { description: '手指細長，深接球點。', size: 12.8 },
  APL_UR008_PLUS: { description: '新型號AKG-GT07同型ERM腕帶型。', size: 13.0 },
  US_OUTFIELDER: { description: '接球點深設計。\n專為外野手設計。', size: 12.5 },
  // ATOMS模型定義 - 捕手用
  AGL_NE002: { description: '接球點不會太深。', size: 12.8 },
  AKG_12: { description: '小巧容易操控。', size: 12.8 },
  AKG_JS2: { description: '較淺的捕手刀模，適合快速拿球。', size: 12.4 },
  APL_UR002_PLUS: { description: '背面開放式ERM背帶提升操控性。', size: 12.8 },
  AKG_GT22: { description: '新型號。標準背面採用手套。', size: 12.8 },
  // ATOMS模型定義 - 一壘手用
  AGL_NE003: { description: '接球點寬，穩定接球的一壘手套。', size: 12.8 },
  AKG_13: { description: '掌心較小，操作性好的型號。', size: 12.8 },
  APL_UR003_PLUS: { description: '小型一壘，操控性好的型號。', size: 12.8 },
  AKG_GT33: { description: '新型號。能穩固接球的新型網採用。', size: 12.8 },
  DRAWING_CAUTION: '※手套・捕手手套的繪製、刺繡位置・字體為示意圖，與實際可能有所不同。',
  DRAWING_SHOES_CAUTION: '※釘鞋・球鞋的繪製、刺繡位置・字體為示意圖，與實際可能有所不同。',
  STAFF_ONLY: '※ATOMS工作人員專用模擬。',
  CATCH_SURFACE: '接球面',
  BACK_SURFACE: '背面',
  SELECTED_BASE_MODEL: '選擇中的基本型號',
  TO_TOP: '回到頂部',
  RESET: '重設',
  SEARCH: '搜尋',
  SEARCHING: '搜尋中...',
  CONFIRM: '確認',
  CONFIRM_TO_TOP: '真的要移動到首頁嗎？',
  CONFIRM_RESET: '真的要重設嗎？\n所有設定將被重設',
  CONFIRM_SEND_EMAIL: '保存資料並發送保存ID到郵件地址。',
  CONFIRM_START_SIMULATION: ' 開始模擬。',
  PARTS_SETTING: '部位設定',
  COLOR_SETTING: '顏色設定',
  EMBROIDERY_SETTING: '刺繡設定',
  BASE_MODEL: '基本型號',
  KINDS: '種類',
  TANNER: '皮革等級',
  ATOMS_LEATHER: '皮革等級',
  ATOMS_LEATHER_RESET_DESCRIPTION: '如需變更，請重置模擬。',
  DOMINANT_ARM: '慣用手',
  BACK_STYLE: '背面樣式',
  MATERIAL_PACK: '掌心穿線',
  FINGER_SIZE: '手指長度',
  BACK_LACE: '手指加強線',
  WEB: '球擋',
  WEB2: '球擋2',
  FINGER_GUARD: '護指套/指片',
  MOLDING_ORDER: '原廠整型',
  FINGER_TIP_OUT: '露指',
  STAND: '手背大片',
  TARGET: '側片',
  PARTS: '部位',
  COLOR: ' 顏色',
  LACE: '帶皮',
  STITCH: '車縫線',
  HAMIDASHI: '夾條',
  EDGE: '滾邊',
  THUMB_HOOK: '大拇指裡帶',
  LITTLE_HOOK: '小指裡帶',
  LININGS: '内裡',
  MOUTON: '羊毛',
  LABEL: 'LOGO顏色',
  THUMB: '拇指',
  THUMB1: '拇指1',
  THUMB_INDEX_MIDDLE5: '拇指・食指・中指5',
  THUMB2: '拇指2',
  THUMB_ROOT: '背帶',
  INDEX: '食指',
  INDEX3: '食指3',
  INDEX4: '食指4',
  MIDDLE: '中指',
  MIDDLE5: '中指5',
  MIDDLE6: '中指6',
  RING: '無名指',
  RING7: '無名指7',
  RING8: '無名指8',
  LITTLE: '小指',
  LITTLE9: '小指9',
  LITTLE10: '小指10',
  THUMB2_INDEX3: '拇指2・食指3',
  THUMB2_INDEX3_MIDDLE4: '拇指2・食指3・中指4',
  THUMB2_INDEX_MIDDLE5: '拇指2・食指3,4・中指5',
  THUMB2_INDEX_MIDDLE_RING7: '拇指2・食指3,4・中指5,6・無名指7',
  INDEX4_MIDDLE5: '食指4・中指5',
  MIDDLE6_RING: '中指6・無名指',
  MIDDLE5_RING6: '中指5・無名指6',
  MIDDLE6_RING7: '中指6・無名指7',
  MIDDLE6_RING_PINKY: '中指6・無名指・小指',
  RING7_LITTLE8: '無名指7・小指8',
  RING8_LITTLE9: '無名指8・小指9',
  BELT: '背帶',
  FIRST_BACK_BELT: '手背調整帶',
  BAND: '背帶',
  UNDER_WEB: 'U型虎口',
  BOOMERANG: '手背四指',
  LOOP_OF_RING: '無名指環',
  POSITION: '位置',
  TYPE_FACE: '字體',
  MAIN_COLOR: '刺繡顏色',
  POINT_COLOR: '重點顏色',
  SHADOW_COLOR: '陰影顏色',
  EDGE_COLOR: '邊框顏色',
  EMBROIDERY_CONTENTS: '刺繡內容',
  ENTER_EMBROIDERY_CONTENTS: '請輸入刺繡內容',
  EMBROIDERY_CONTENT_DIALOG_TITLE: '刺繡{n} - {summary}',
  EMBROIDERY_CONTENT_INPUT_COMPLETE: '輸入完成',
  MAX_NUMBER_OF_CHAR: '最大字數',
  CHARACTERS: '文字',
  BASE_ITEMS: '基本項目',
  COLOR_ITEMS: '顏色項目',
  PRICE_ITEMS: '價格項目',
  EMBROIDERY_ITEMS: '刺繡項目',
  NO_EMBROIDERY: '無刺繡',
  BASE_PRICE: '基本金額：',
  EMBROIDERY_PRICE: '刺繡金額：',
  OPTION_PRICE: '選配金額：',
  SHIPPING_PRICE: '運費：',
  TOTAL_PRICE: '合計金額：',
  MONEY_UNIT: '日幣',
  SIZE_UNIT: ' inch',
  COPY: '複製',
  COPIED: '已複製',
  SAVED_ID: '保存ID',
  SAVE_CAUTION: '請預先透過截圖等方式保存模擬內容。',
  CUSTOMER_INFORMATION: '客戶資訊',
  CUSTOMER_NAME: '客戶姓名',
  CUSTOMER_INFORMATION_CAUTION: '選擇所有項目後，可輸入客戶資訊。',
  DUPLICATE_EMBROIDERY_POSITION_CAUTION: '刺繡位置重複。請再次確認無重複。',
  LEAGUE: '打球層級',
  FIELD_POSITION: '守備位置',
  EMAIL_ADDRESS: 'e-mail',
  EMAIL_ADDRESS_RETYPE: 'e-mail(再次輸入)',
  SAVE_BUTTON: '保存',
  NOW_SAVING: '保存中...',
  RETAIL_LOGIN_PAGE_HEADER: '零售店用登入畫面',
  RETAIL_LOGIN_PAGE_EXPLAIN: '零售店員請登入後用ID搜尋客戶的模擬結果',
  LOGIN: '登入',
  NOW_LOGING: '登入中...',
  NOW_LOADING: '讀取中...',
  BACK_TO_TOP: '返回首頁',
  PASSWORD: '密碼',
  RESET_PASSWORD: '重設密碼',
  PAGE_OF_RESET_PASSWORD: '零售店用密碼重設畫面',
  DESCRIPTION_OF_HOW_TO_RESET_PASSWORD: '請輸入相應的郵件地址，按發送按鈕。',
  SEND_RESET_EMAIL: '發送重設郵件',
  TO_RETAIL_LOGIN_PAGE: '前往零售店登入畫面',
  CAUTION_SENT_RESET_EMAIL: '已發送。如未收到，請確認是否被歸類為垃圾郵件。',
  SELECT_BRAND: '選擇品牌',
  SELECT_PRODUCT: '選擇產品',
  SIMULATION_ID: '模擬ID',
  ENTER_ID: '輸入ID',
  LOGOUT: '登出',
  RETAIL_CAUTION_1: '此品牌不在處理對象內，無法搜尋。',
  RETAIL_CAUTION_2: '搜尋的模擬ID在選擇的品牌中未找到。請選擇正確品牌。',
  NAME: '姓名：',
  TEL: '電話：',
  REMARK: '備註欄：',
  CUSTOMER_FORM_CAUTION_1: '※價格可能在不通知的情況下變更。',
  CUSTOMER_FORM_CAUTION_2: '※備註欄記載的要求可能無法滿足。',
  CUSTOMER_FORM_CAUTION_3: '※特殊要求等請聯絡代理店負責人。',
  MAIN_COLOR_PRICE: 3300,
  SHADOW_COLOR_PRICE: 3960,
  EDGE_COLOR_PRICE: 6160,
  TANNER_OBJECTS: tannerObjs,
  TANNER_OBJECTS_US: tannerTwObjs,
  DOMINANT_ARM_OBJECTS: dominantArmTwObjs,
  BACK_STYLE_OBJECTS: backStyleTwObjs,
  BACK_STYLE_FOR_PITCHER_OBJECTS: backStyleForPitcherTwObjs,
  BACK_STYLE_FOR_CATCHER_OBJECTS: backStyleForCatcherMittTwObjs,
  RESELECT_LABEL_BEFORE_BACK_STYLE: '變更前，請先從 L, M, N, O, P, Q, R, Z 中重新選擇ATOMS標籤。',
  FINGER_GUARD_TYPE_DESCRIPTION: '請先選擇背面樣式。',
  MATERIAL_PACK_OBJECTS: materialPackTwObjs,
  SIZE_OBJECTS: sizeTwObjs,
  MOLDING_OBJECTS: moldingTwObjs,
  LOOP_OF_RING_FINGER_OBJECTS: loopOfRingFingerTwObjs,
  LOOP_OF_RING_FINGER_DESCRIPTION: '選配：4,620日幣, ※顏色與内裡相同。',
  BACK_LACE_OBJECTS: backLaceTwObjs,
  FINGER_GUARD_TYPE_FOR_OUTFIELDER_OBJECTS: fingerGuardTypeForOutfielderTwObjs,
  FINGER_GUARD_TYPES_FOR_FIRST_BASEMAN: fingerGuardForFirstMittTwObjs,
  FINGER_GUARD_TYPE_OBJECTS: fingerGuardTypeTwObjs,
  FINGER_GUARD_TYPE_ALL_OBJECTS: fingerGuardTypeAllTwObjects,
  CAUTION_TANNER: '※適用於部分部位的顏色',
  CAUTION_DOMINANT_ARM: '',
  CAUTION_SIZE: '改變尺寸需要選配費用。',
  CAUTION_MOLDING_ORDER: '選配: 5,500元',
  CAUTION_LACE: '白芯帶皮斷面為白色。不會呈現在模擬中。',
  CAUTION_BACK_STYLE: '要變更時，請先將護指套設為"無"。',
  LACE_COLOR_OBJECTS: laceColorTwObjs,
  EDGE_COLOR_OBJECTS: BINDING_COLORS_TW,
  STITCH_COLOR_OBJECTS: stitchColorTwObjs,
  HAMIDASHI_COLOR_OBJECTS: hamidashiTwObjs,
  HAMIDASHI_COLOR_ALL_OBJECTS: hamidashiAllTwObjs,
  HAMIDASHI_COLOR_FOR_CATCHER_OBJECTS: hamidashiForCatcherTwObjs,
  MOUTON_COLOR_OBJECTS: listLiningsMaterialTwObjs,
  LABEL_COLOR_OBJECTS: atomsLabelTwObjs,
  SELECT_BACK_STYLE_DESCRIBE: '請先選擇背面樣式。',
  DISPATCH_COLOR_OBJECTS: dispatchTwObjects,
  DISPATCH_EUROPEAN_LEATHER_COLOR_OBJECTS: dispatchEuropeanSteerTw,
  DISPATCH_NORTH_LEATHER_COLOR_OBJECTS: dispatchNorthSteerTw,
  DISPATCH_STEER_LEATHER_COLOR_OBJECTS: dispatchSteerTw,
  DISPATCH_US_LEATHER_COLOR_OBJECTS: dispatchTwObjects,
  CATCH_FACE_OBJECTS: catchFacePartsTwObjs,
  CATCH_FACE_FOR_CATCHER_OBJECTS: catcherMittCatchFaceTwObjs,
  FIRST_BACK_OBJECTS: gloveFirstBackPartsTwObjs,
  CROWN_BACK_OBJECTS: gloveCrownBackPartsTwObjs,
  BELT_BACK_OBJECTS: gloveBeltBackPartsTwObjs,
  US_MODEL_BACK_OBJECTS: gloveUsBackPartsTwObjs,
  UBACK_OBJECTS: gloveBeltBackPartsTwObjs,
  NO_BELT_BACK_OBJECTS: gloveBeltBackPartsNoBeltTwObjs,
  C_MITT_REGULAR_BACK_OBJECTS: catcherMittBackofRegularBackStylePartsTwObjs,
  C_MITT_BELT_BACK_OBJECTS: catcherMittBackofBeltBackStylePartsTwObjs,
  C_MITT_BACK_OBJECTS: catcherMittBackPartsTwObjs,
  F_MITT_NO_BELT_BACK_OBJECTS: firstMittBackPartsNoBeltTwObjs,
  F_MITT_BACK_OBJECTS: firstMittBackPartsTwObjs,
  EMBROIDERY_POSITION_OBJECTS: positionTwObjs,
  PAYMENT_MANAGEMENT: '支付管理',
  ORDER_SPECIFICATION: '訂單明細',
  ORDER_DATE: '發行日',
  ORDERING_PARTY: '發包方',
  NO_EMBROIDERY_SELECTED: '未選擇刺繡',

  // Legal page
  LEGAL_TITLE: '特定商業交易法表記',
  LEGAL_DESCRIPTION: '根據特定商業交易法，表記如下。',
  LEGAL_ITEM: '項目',
  LEGAL_CONTENT: '內容',
  LEGAL_COMPANY_NAME: '銷售業者名',
  LEGAL_COMPANY_NAME_VALUE: 'ATOMS股份有限公司（ATOMS, inc）',
  LEGAL_REPRESENTATIVE: '負責人姓名',
  LEGAL_REPRESENTATIVE_VALUE: '代表董事社長 石川 佳和',
  LEGAL_ADDRESS: '地址',
  LEGAL_ADDRESS_VALUE: '〒633-0067 奈良縣櫻井市大福156-4',
  LEGAL_PHONE: '電話號碼',
  LEGAL_PHONE_VALUE: '0744-46-5181',
  LEGAL_EMAIL: '電子郵件地址',
  LEGAL_EMAIL_VALUE: 'atoms.sns@gmail.com',
  LEGAL_CONTACT: '聯絡我們',
  LEGAL_CONTACT_VALUE: 'https://atoms-inc.com/contact/',
  LEGAL_PAYMENT_METHOD: '付款方式',
  LEGAL_PAYMENT_METHOD_VALUE: '信用卡, Apple Pay',
  LEGAL_OTHER_FEES: '商品價格以外的必要費用',
  LEGAL_OTHER_FEES_VALUE: '運費：全日本一律1,100日圓（含稅）',
  LEGAL_TAX: '消費稅',
  LEGAL_TAX_VALUE: '所有商品的顯示價格均為含消費稅的價格。',
  LEGAL_RETURN_POLICY: '退貨・取消相關',
  LEGAL_RETURN_POLICY_VALUE: '由於是接單生產，訂購後恕不接受取消・退貨。\n\n商品將於您下單後開始製造。恕不接受客戶個人原因的退貨・交換。',
  LEGAL_DELIVERY_TIME: '交貨時期',
  LEGAL_DELIVERY_TIME_VALUE: '通常，訂單確認後3個月內交貨。\n※繁忙期可能需要更長的交貨時間。',
  PRINT_LEATHER_TYPE: '印刷皮革',
  PRINT_LEATHER_TYPE_DESCRIPTION: '選擇後手套背面將全部使用印刷皮革。',
  PRINT_LEATHER_TYPE_OBJECTS: printLeatherTypeTwObjs,
  SERIES: '系列',
  FINGER_PAD: '指片',
  LEATHER_INTEGRATED_INDEX: '皮革一體成型(食指)',
  LEATHER_INTEGRATED_MIDDLE: '皮革一體成型(中指)',
  LEATHER_INTEGRATED_RING: '皮革一體成型(無名指)',
  ORIGINAL_EMBROIDERY: '原創刺繡',
  DIRECT_LOGO_EMBROIDERY_1: '直接標誌刺繡1',
  DIRECT_LOGO_EMBROIDERY_1_MAIN_COLOR: '直接標誌刺繡1 主體顏色',
  DIRECT_LOGO_EMBROIDERY_1_EDGE_COLOR: '直接標誌刺繡1 邊框顏色',
  DIRECT_LOGO_EMBROIDERY_2: '直接標誌刺繡2',
  DIRECT_LOGO_EMBROIDERY_2_COLOR: '直接標誌刺繡2 顏色',
  BREAD_CRUMB_TRAIL_YSR: '硬式手套 / Yell story / 內野手用',
  BRAND_SELECTION_PAGE_HEADLINE_US_MODEL: 'ATOMS (美規)',
  BRAND_SELECTION_PAGE_HEADLINE_JAPAN_MODEL: 'ATOMS (日規)'
}
